// Vendor Libs
import React from 'react';

// Components
import ExternalNetworkForm from '../app/external-network-form';
import Permissions from '../core/permissions';

// Containers
import FormData from '../../containers/form-data';

const formName = 'createExternalNetwork';

const CreateExternalNetwork = () => (
    <Permissions
        accessRequirement="create"
        elementService="externalNetwork"
        notAuthorizedMessage={true}
        requiresServiceAccess={true}
    >
        <FormData formName={formName}>
            {({resetForm}) => (
                <ExternalNetworkForm
                    className="create-external-network"
                    editing={false}
                    formName={formName}
                    onReset={resetForm}
                />
            )}
        </FormData>
    </Permissions>
);

export default CreateExternalNetwork;
